import { createRoot } from 'react-dom/client';
import ParcoursApp from './parcours';
import '../assets/app.css';

createRoot(document.body).render(<ParcoursApp />);
